import * as formConfig from './formConfig';

export { formConfig };

export const warrantyIds = {
  notWarranty: 0,
  possWarranty: 2,
  warranty: 1,
};

export const tooltipTitles = {
  [warrantyIds.notWarranty]: {
    active: 'Перевести заявку в возможно гарантийную',
  },
  [warrantyIds.possWarranty]: {
    active: 'Возможно гарантийная. Перевести в обычную/гарантийную',
    inactive: 'Возможно гарантийная',
  },
  [warrantyIds.warranty]: {
    active: 'Гарантийная. Перевести в обычную',
    inactive: 'Гарантийная',
  },
};

export const modes = {
  regularToPossWarranty: 'regularToPossWarranty',
  possWarrantyToRegular: 'possWarrantyToRegular',
  possWarrantyToWarranty: 'possWarrantyToWarranty',
  warrantyToRegular: 'warrantyToRegular',
};

export const modalTitles = {
  [modes.regularToPossWarranty]: (requestId) =>
    `Перевод заявки ${requestId} в возможно гарантийную`,

  [modes.possWarrantyToRegular]: (requestId) =>
    `Перевод заявки ${requestId} в обычную`,

  [modes.possWarrantyToWarranty]: (requestId) =>
    `Перевод заявки ${requestId} в гарантийную`,

  [modes.warrantyToRegular]: (requestId) =>
    `Перевод заявки ${requestId} в обычную`,
};
